import { PaymentInterval, Plan, PlanCategory } from '@/shared/types/Billing';

import { PRICING_CARD_DISCOUNT } from '../constants/pricingCardDiscound';

type UseChipLabelParams = {
  plan: Plan;
  selectedPaymentPeriod: PaymentInterval;
};

export const useChipLabel = ({ plan, selectedPaymentPeriod }: UseChipLabelParams): null | string => {
  const isYearlySelected = selectedPaymentPeriod === PaymentInterval.Year;
  const isCreatorPro = plan.category === PlanCategory.CreatorPro;
  const discountConfig = PRICING_CARD_DISCOUNT[plan.category as keyof typeof PRICING_CARD_DISCOUNT];

  // Annual keeps the promo-code chips; monthly flags Creator Pro as "Most popular".
  if (isYearlySelected && discountConfig) {
    const percent = Math.round(discountConfig.year * 100);
    return `-${percent}% with code ${discountConfig.code}*`;
  }

  if (!isYearlySelected && isCreatorPro) {
    return 'Most popular';
  }

  return null;
};
